"use client"
import { Badge } from "primereact/badge";

const LabelEnv = () => {
  return (
    process.env.NEXT_PUBLIC_ENV_DESCRICAO
    && <div className="justify-content-center flex-wrap w-100 text-center"><Badge value={process.env.NEXT_PUBLIC_ENV_DESCRICAO} severity="danger" style={{ borderRadius: 3 }} className='m-2'></Badge>
    </div>
 )
}

export {
  LabelEnv
}